import React, { useEffect, useRef, useState } from "react";
import { Image, Smile, SendHorizonal } from "lucide-react";
import { io } from "socket.io-client";
import Layout from "../../components/Layout";
import { AlertCircle } from "lucide-react";

import chatbotIcon from "../../assets/images/chatbot-icon.png";
import typingIcon from "../../assets/icons/typing.svg";
import { useStores } from "../../use.store";
import { getFormattedDate } from "../../helpers";
import { observer } from "mobx-react-lite";

import ImageUploadBottomSheet from "../../components/ImageUploadIcon";
import socketService from "../../services/chatSocketService";
import {
  createNewTicket,
  joinChatRoom,
  respondToCall,
  sendCallInvite,
} from "../../services/chatService";
import { auth } from "../../services/api";
import { sendMessage as sendMessageAPI } from "../../services/chatService";
import ModalUserInfoForChatWithCS from "../../components/ModalUserInfoForChatWithCS";
import { useNavigate } from "react-router-dom";
import VoiceCallInterface from "../../components/VoiceCallInterface";
import { checkMessage } from "../../utils/badWordsFilter";

const CustomerServiceChatPage = observer(() => {
  const { mapStore, mainStore } = useStores();

  const [isOpenModalVoiceCall, setIsOpenModalVoiceCall] = useState(false);
  const [history, setHistory] = useState([]);
  const [stageType, setStageType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [text, setText] = useState("");
  const [callData, setCallData] = useState();
  const [isOpenModalUser, setIsOpenModalUser] = useState(true);
  const [isShowExitChat, setIsShowExitChat] = useState(false);
  const [userFormData, setUserFormData] = useState({
    name: "botanic user",
    email: "user@botanic.com",
    issue: "",
  });
  const [isReadyToChat, setIsReadyToChat] = useState(false);

  const [isBottomSheetImageOpen, setIsBottomSheetImageOpen] = useState(false);

  const [websocketError, setWebsocketError] = useState();

  const [userTicketData, setUserTicketData] = useState();
  // get from auth response
  const [userData, setUserData] = useState();

  const messagesEndRef = useRef(null);

  const navigate = useNavigate();

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    // Use setTimeout to ensure DOM has updated before scrolling
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  }, [mainStore.customerChatHistory]);

  // Also scroll when history changes
  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  }, [history]);

  // Also scroll when bot typing status changes
  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  }, [mainStore.isBotTyping]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShowExitChat(true);
    }, 10000);

    // Cleanup function to clear timeout if component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isOpenModalUser) {
      if (userFormData.name && userFormData.email) {
        setIsReadyToChat(true);
      }
    }
  }, [isOpenModalUser, userFormData]);

  useEffect(() => {
    if (!isReadyToChat) return;
    const initializeSocket = async () => {
      try {
        // Connect to socket service
        await socketService.connect();

        socketService.onConnect((data) => {
          if (userTicketData) {
            joinChatRoom(
              userTicketData?._id,
              userData?.id,
              userData?.role,
              userFormData.name,
            );
          }
        });

        // Set up connection event listeners
        socketService.onMessage((message) => {
          console.log(
            "New message received:",
            message,
            mainStore.latestMessageSentByUser.chatMsg,
            message.message.content,
          );
          if (
            mainStore.latestMessageSentByUser.chatMsg ===
            message.message.content
          ) {
            return;
          }
          const newChat = {
            isUser: false,
            chatMsg: message.message.content,
            chatMsgTime: getFormattedDate(),
            type: message.message.messageType,
            fileAttachment: message.message.fileAttachment,
          };
          setHistory((prevHistory) => [...prevHistory, newChat]);
        });

        socketService.onTyping((data) => {
          console.log("User typing:", data);
        });

        socketService.onVoiceCallInvite((data) => {
          console.log("Voice call invite received:", data);
          setCallData({
            ...data,
            type: "voice",
          });
          handleInvitationVoiceCall();
        });

        socketService.onVoiceCallResponse((data) => {
          console.log("Voice call response received:", data);
        });

        socketService.onVoiceCallResponse((data) => {
          console.log("Voice call response received:", data);
        });
      } catch (error) {
        console.log("Error connecting to Socket.IO server:", error);
      }
    };
    initializeSocket();
  }, [isReadyToChat]);

  const addInitialMessage = () => {
    const messageText = "You will be connected to the live support shortly";

    setHistory((prevHistory) => {
      const alreadyExists = prevHistory.some(
        (item) => item.chatMsg === messageText,
      );

      if (alreadyExists) return prevHistory;

      const newChat = {
        isUser: false,
        chatMsg: messageText,
        chatMsgTime: getFormattedDate(),
        type: "text",
        fileAttachment: null,
      };

      return [...prevHistory, newChat];
    });
  };

  useEffect(() => {
    if (!isReadyToChat) return;
    try {
      if (socketService.getConnectionStatus()) {
        addInitialMessage();
        joinChatRoom(
          userTicketData?._id,
          userData?.id,
          userData?.role,
          userFormData.name,
        );
      }
    } catch (error) {
      console.log("Error connecting to Socket.IO server:", error);
    }
  }, [isReadyToChat, socketService.isConnected]);

  useEffect(() => {
    const createTicket = async () => {
      try {
        const email = "testing.live-chat@adactive.asia";
        const password = "Password12!12";
        const responseData = await auth(email, password);
        setUserData(responseData);
        await handleCreateNewChat(responseData);
      } catch (error) {
        console.log("Error connecting to Socket.IO server:", error);
      }
    };
    if (!isReadyToChat) return;
    createTicket();
  }, [isReadyToChat]);

  const handleCreateNewChat = async (resUserData) => {
    if (userTicketData) return;
    try {
      // First create a ticket with user's input data
      const ticketData = {
        name: userFormData.name,
        location: "botanic garden",
        issue: userFormData.issue,
        description: "New chat conversation",
        status: "open",
        siteId: mainStore.config.adsignId,
      };

      const newTicketResponse = await createNewTicket(ticketData);
      setUserTicketData(newTicketResponse.data);
      localStorage.setItem(
        "userTicket",
        JSON.stringify(newTicketResponse.data),
      );
      console.log("New ticket created:", newTicketResponse);
      joinChatRoom(
        newTicketResponse.data?._id,
        resUserData?.id,
        resUserData?.role,
        userFormData.name,
      );
    } catch (error) {
      console.error("Failed to create new chat:", error);
      message.error("Failed to create new chat. Please try again.");
    }
  };

  const sendMessage = async (
    content,
    messageType = "text",
    replyTo = null,
    fileAttachment = null,
  ) => {
    try {
      setIsLoading(true);
      const foundInappropriate = checkMessage(content);

      if (foundInappropriate.length > 0) {
        setIsLoading(false);
        alert(
          `Your message contains inappropriate content and cannot be sent. Detected words: ${foundInappropriate.join(
            ", ",
          )}`,
        );
        return;
      }
      const messageData = {
        ticketId: userTicketData?._id,
        content,
        messageType,
        replyTo,
        senderId: userData?.id,
        senderName: userData?.name,
        senderRole: userData?.role,
        fileAttachment,
      };

      // Send message via socket only (backend handles saving and broadcasting)
      const response = await sendMessageAPI(messageData);

      if (response.success) {
        const newChat = {
          isUser: true,
          chatMsg: content,
          chatMsgTime: getFormattedDate(),
          type: messageType,
          fileAttachment: fileAttachment,
        };
        mainStore.setLatestMessageSentByUser(newChat);
        setHistory((prevHistory) => [...prevHistory, newChat]);
        setText("");
        setIsLoading(false);
        return response;
      }
      setIsLoading(false);
    } catch (error) {
      message.error("Failed to send message");
      console.error("Error sending message:", error);
      setIsLoading(false);
      throw error;
    }
  };

  const selectImages = async (images) => {
    images.map(async (image) => {
      const messageType = image.mimeType.startsWith("image/")
        ? "image"
        : image.mimeType.startsWith("video/")
          ? "video"
          : "file";
      await sendMessage(image.fileName, messageType, null, image);
    });
  };

  const handleInvitationVoiceCall = () => {
    const newChat = {
      isUser: false,
      chatMsg: "You`ve invited to call",
      chatMsgTime: getFormattedDate(),
      type: "text",
      showOptionToCall: true,
    };
    mainStore.setLatestMessageSentByUser(newChat);
    setHistory((prevHistory) => [...prevHistory, newChat]);
  };

  const respondInvitationCall = async (value) => {
    if (value) {
      await acceptCall();
    } else {
      await declineCall();
    }
    setIsOpenModalVoiceCall(value);
    history.map((data) => (data.showOptionToCall = false));
  };

  const respondToCallInvite = async () => {
    try {
      const ticketId = userTicketData?._id;
      const callId = callData.callId;
      const response = "accepted";

      const apiResponse = await respondToCall(callId, response, ticketId);

      if (apiResponse.success) {
        const responseMessage = apiResponse.data;
        const ticketId = responseMessage.ticketId;

        // Send via socket for real-time delivery
        socketService.respondToVoiceCall(responseMessage);

        return apiResponse;
      }
    } catch (error) {
      console.error("Error responding to call:", error);
    }
  };

  const acceptCall = async () => {
    if (!callData) return;

    try {
      // First respond via API using the message ID
      await respondToCallInvite(callData.message._id, "accepted");

      // Then send socket response with all required data
      const responseData = {
        callId: callData.callId,
        ticketId: callData.ticketId,
        messageId: callData.message._id,
        response: "accepted",
      };

      socketService.respondToVoiceCall(responseData);
      setCallData(null);
    } catch (error) {
      console.error("Error accepting call:", error);
    }
  };

  const declineCall = async () => {
    if (!callData) return;

    try {
      // First respond via API using the message ID
      await respondToCallInvite(callData.message._id, "declined");

      // Then send socket response with all required data
      const responseData = {
        callId: callData.callId,
        ticketId: callData.ticketId,
        messageId: callData.message._id,
        response: "declined",
      };

      socketService.respondToVoiceCall(responseData);
      setCallData(null);
    } catch (error) {
      console.error("Error declining call:", error);
    }
  };

  return (
    <Layout>
      {isOpenModalUser && (
        <ModalUserInfoForChatWithCS
          onClose={() => {
            setIsOpenModalUser(false);
            navigate("/general-enquiries");
          }}
          onCloseModal={() => setIsOpenModalUser(false)}
          formData={userFormData}
          setFormData={setUserFormData}
        />
      )}

      {/* Header */}
      <div className="w-full bg-green-900 text-white flex items-center justify-center py-4 border-b-2 border-blue-400 h-[62px]">
        <h1 className="text-lg font-semibold">Customer Service</h1>
      </div>
      {websocketError && (
        <div className="bg-red-50 border border-red-200 rounded-md p-3 m-4">
          <div className="flex items-center gap-2 text-red-800">
            <AlertCircle className="w-4 h-4" />
            <span className="font-medium">Error:</span>
          </div>
          <p className="text-red-700 mt-1">{websocketError}</p>
        </div>
      )}

      {/* Chat Content */}
      {!websocketError && (
        <div className="flex flex-col h-full items-start w-full max-w-md p-4 h-4/5 overflow-y-auto">
          {history.map((chat) => {
            return (
              <div className="flex flex-col w-full">
                {chat.isUser ? (
                  <div className="flex flex-col items-end mb-2">
                    <div
                      className={`${chat.type === "text" ? "w-full" : ""} pr-4`}
                    >
                      <div className="bg-[#75787B] text-white p-4 rounded-xl rounded-br-none">
                        {chat.type === "text" ? (
                          <p>{chat.chatMsg}</p>
                        ) : chat.type === "image" ? (
                          <img
                            src={chat.fileAttachment.fileUrl}
                            className="w-[160px] h-30"
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="flex flex-row justify-start">
                        <p className="text-xs text-gray-500 mt-1">
                          {chat.chatMsgTime}
                        </p>
                      </div>
                    </div>
                    {/* Avatar */}
                    {/* <div className="bg-yellow-100 rounded-full flex items-center justify-center mr-2 mt-[-20px]">
                      <img src={chatbotIcon} className="w-10 h-10" />
                    </div> */}
                  </div>
                ) : (
                  <div className="flex flex-col items-start mb-2">
                    <div
                      className={`${chat.type === "text" ? "w-full" : ""} pl-4`}
                    >
                      <div className="bg-[#215732] text-white p-4 rounded-xl rounded-bl-none">
                        {chat.type === "text" ? (
                          <p>{chat.chatMsg}</p>
                        ) : chat.type === "image" ? (
                          <img
                            src={chat.fileAttachment.fileUrl}
                            className="w-[160px] h-30"
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="flex flex-row justify-end">
                        <p className="text-xs text-gray-500 mt-1">
                          {chat.chatMsgTime}
                        </p>
                      </div>
                    </div>
                    {/* Avatar */}

                    <div className="flex flex-row">
                      {/* <div className="bg-yellow-100 rounded-full flex items-center justify-center mr-2 mt-[-20px] w-12 h-max">
                        <img src={chatbotIcon} className="w-10 h-10" />
                      </div> */}
                      {chat?.showOptionToCall && (
                        <div className="flex flex-col gap-y-1 w-full mt-[-10px]">
                          <div
                            onClick={() => respondInvitationCall(true)}
                            className="flex flex-row justify-center items-center bg-[#A09200] rounded rounded-md text-white p-2 text-[10px] w-[165px]"
                          >
                            Accept
                          </div>

                          <div
                            onClick={() => respondInvitationCall(false)}
                            className="flex flex-row justify-center items-center bg-[#A09200] rounded rounded-md text-white p-2 text-[10px] w-[165px]"
                          >
                            Reject
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}

          {mainStore.isBotTyping && (
            <div className="flex flex-col w-full">
              <div className="flex flex-col items-start mb-2">
                <div className="pl-4">
                  <div className="bg-[#215732] text-white p-4 rounded-xl rounded-bl-none">
                    <img src={typingIcon} />
                  </div>
                  <div className="flex flex-row justify-end"></div>
                </div>
                {/* Avatar */}
                {/* <div className="bg-yellow-100 rounded-full flex items-center justify-center mr-2 mt-[-20px]">
                  <img src={chatbotIcon} className="w-10 h-10" />
                </div> */}
              </div>
            </div>
          )}

          <div ref={messagesEndRef}> </div>
        </div>
      )}

      <div className="flex flex-row items-center justify-center">
        <button
          onClick={() =>
            navigate(`/feedback-page?ticketId=${userTicketData?._id}`)
          }
          className="bg-red-500 w-[120px] items-center text-white text-xs font-serif px-2 py-2 rounded-[10px] shadow-md hover:bg-red-600 transition"
        >
          Exit Chat
        </button>
      </div>

      {/* Chat Input */}
      {!websocketError && (
        <div className="w-full max-w-md bg-white flex items-center gap-2 px-4 p-4 border-t mt-2">
          {/* <Smile className="text-gray-500 w-5 h-5" /> */}
          <input
            type="text"
            placeholder="Ask anything..."
            className="flex-1 px-4 py-2 text-base"
            onChange={(e) => setText(e.target.value)}
            value={text}
          />

          <Image
            className="text-gray-500 w-5 h-5"
            onClick={() => setIsBottomSheetImageOpen(true)}
          />

          {!isLoading && (
            <button
              className="bg-green-900 text-white p-3 rounded-full"
              onClick={() => sendMessage(text)}
            >
              <SendHorizonal className="w-4 h-4" />
            </button>
          )}
          {isBottomSheetImageOpen && (
            <ImageUploadBottomSheet
              onClose={() => setIsBottomSheetImageOpen(false)}
              ticketId={userTicketData?._id}
              onSelect={selectImages}
            />
          )}
        </div>
      )}

      {isOpenModalVoiceCall && (
        <VoiceCallInterface
          onClose={() => {
            setIsOpenModalVoiceCall(false);
            const newChat = {
              isUser: false,
              chatMsg: "Call Ended",
              chatMsgTime: getFormattedDate(),
              type: "text",
            };
            mainStore.setLatestMessageSentByUser(newChat);
            setHistory((prevHistory) => [...prevHistory, newChat]);
          }}
        />
        // <IncomingCallModal
        //   isOpen={isOpenModalVoiceCall}
        //   callerName={
        //     callData?.fromName ||
        //     callData?.message?.senderName ||
        //     "Unknown Caller"
        //   }
        //   callType={callData?.type || "voice"}
        //   onAccept={acceptCall}
        //   onDecline={declineCall}
        //   onClose={() => setCallData(null)}
        // />
      )}
    </Layout>
  );
});

export default CustomerServiceChatPage;
